export default __webpack_public_path__ + "static/media/armChair.5878e549.png";